const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const Globals = require('../../../app/globals');

const OIDCActions = Reflux.createActions({
    getOpenIdProviders: { children: ['completed', 'failed'] },
    addOpenIdProvider: { children: ['completed', 'failed'] },
});

OIDCActions.getOpenIdProviders.listen(function(actionId) {
    ServerRequest.makeRequest(`/authoring/oidc/providers`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

OIDCActions.addOpenIdProvider.listen(function(actionId,params) {
        ServerRequest.makeRequest(('/authoring/oidc/provider/add'), 'POST', JSON.stringify(params))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});


module.exports = OIDCActions;